export default __webpack_public_path__ + "static/media/quickie_coin_video.2be73dee.mp4";